import ReactDOM from 'react-dom';
import Constantes from './utils/Constantes';
// third party
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

// project imports
import * as serviceWorker from 'serviceWorker';
import App from 'App';
import { store } from 'store';

// style + assets
import 'assets/scss/style.scss';

// ==============================|| REACT DOM RENDER  ||============================== //

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);
// This is necesary to lock rigth click
document.addEventListener('contextmenu', (event) => event.preventDefault());
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

document.title = Constantes.tituloApp;

onkeydown = (e) => {
    const tecla = e.which || e.keyCode;

    // Evaluar si se ha presionado la tecla Ctrl:
    /*
    if (e.ctrlKey) {
        // Evitar el comportamiento por defecto del nevagador:
        e.preventDefault();
        e.stopPropagation();
    }
    */
};
